import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, Typography } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import useAlias from '@src/hooks/useAlias';
import React from 'react';
import { useFormOperations } from '../hooks';
import { useSettings } from '../hooks/useSettings';

interface GroupHeaderProps {
  group: {
    uiLabel: string;
    controllerField: string;
  };
  groupIndex: number;
}

const GroupHeader: React.FC<GroupHeaderProps> = ({ group, groupIndex }) => {
  const alias = useAlias();
  const { startEditSetting: handleEditSetting } = useSettings();

  const { showDeleteConfirm } = useFormOperations();
  return (
    <Grid2 size={12} sx={{ mt: groupIndex > 0 ? 2 : 0 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant='subtitle1' fontWeight='bold'>
          {group.uiLabel}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <IconButton
            size='small'
            sx={{ opacity: 0.6, color: 'primary.main' }}
            onClick={() => handleEditSetting({ ...group, fields: [] })}
            title={alias('Edit setting')}
          >
            <EditIcon fontSize='small' />
          </IconButton>
          <IconButton
            size='small'
            sx={{ opacity: 0.6, color: 'error.main' }}
            onClick={() => showDeleteConfirm('setting', group.controllerField)}
            title={alias('Delete setting')}
          >
            <DeleteOutlineIcon fontSize='small' />
          </IconButton>
        </Box>
      </Box>
    </Grid2>
  );
};

export default GroupHeader;
